<TabPanel
    id="participantsSection"
    labelledBy="participantsTab"
    preloadContent={false}
    type="container"
    {participants}
>
    <SearchableList
        bind:allChecked={allChecked}
        bind:items={items}
        {searchFunction}
        {searchLabel}
        {searchPlaceholder}
        {searchValue}
    >
        <AssignToModalParticipantHeader slot="headerTemplate" />
        <AssignToModalParticipantRow slot="rowTemplate" let:item item={item} />
    </SearchableList>
</TabPanel>

<script>
    import TabPanel from "@itslearning/prometheus/assets/Navigation/Tabs/v1/TabPanel.svelte";
    import SearchableList from "@its-ui/planner-common/components/SearchableList/SearchableList.svelte";
    import i18n from "@its-ui/planner-common/i18n";
    import AssignToModalParticipantHeader from "./AssignToModalParticipantHeader.svelte";
    import AssignToModalParticipantRow from "./AssignToModalParticipantRow.svelte";
    import { onMount } from "svelte";

    let items = [];

    const searchFunction = (searchTerm) => (item) =>
        item.displayName.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.userName.toLowerCase().includes(searchTerm.toLowerCase());
    const searchValue = "";

    const searchLabel = i18n.searchForParticipants;
    const searchPlaceholder = i18n.searchForParticipants;

    export let isFirstLoad = false;
    export let participants;

    $: {
        for (const item of items) {
            participants.entityArray.find((participant) => participant.personId === item.personId).isAssigned = item.checked;
        }
    }

    $: allChecked = !isFirstLoad && items.every((item) => item.isAssigned);

    onMount(async () => {
        const areAllStudentsAssign = participants.entityArray.every((item) => item.isAssigned);
        items = participants.entityArray.map((item) => ({ ...item, checked: isFirstLoad ? false : (areAllStudentsAssign ? false : item.isAssigned) }));
    });
</script>
